import validate from "/Users/demir/projects/inanctur/inanctur.com.tr/node_modules/nuxt/dist/pages/runtime/validate.js";
import meta_45global from "/Users/demir/projects/inanctur/inanctur.com.tr/middleware/meta.global.js";
import manifest_45route_45rule from "/Users/demir/projects/inanctur/inanctur.com.tr/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  meta_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}